// AboutForm.js
// AboutForm.js
import React from 'react';
import './AboutForm.css';

const AboutContent = () => (
    <div className="add-gardener-form-container">
      <div className="add-gardener-form">
                  <h1 className="form-heading">About GrowYourFoodApp</h1>

        <div className="about">

          <h2>Vision Statement</h2>
          <p>
            GrowYourFoodApp is creating a future where local food isn't just grown -
            it's lived, shared, and sustained.
          </p>

          <p>We guide people through the full cycle of food:</p>
          <ul>
            <li>
              <strong>From seed to harvest</strong> - empowering gardeners to plant,
              nurture, and pick crops year round.
            </li>
            <li>
              <strong>From harvest to meal</strong> - helping households eat seasonally,
              plan meals around what's fresh, and reduce reliance on grocery chains.
            </li>
            <li>
              <strong>From meal to preservation</strong> - showing how to freeze, can,
              dry, or ferment surplus so nothing is wasted, and every pantry becomes a
              storehouse of local abundance.
            </li>
          </ul>

          <p>
            By partnering with nurseries and farmstands, we extend this cycle beyond
            the garden. Non-gardeners can join the same journey by sourcing what's in
            season locally, while gardeners gain new outlets to share excess harvests.
            Together, we create a regional food ecosystem where growing, eating, and
            preserving flow seamlessly into one another.
          </p>

          <p>
            Our vision is simple yet transformative: to make year-round local food
            accessible, practical, and inspiring - turning every household into a
            steward of health, sustainability, and community.
          </p>

          <h2>Our Values</h2>
          <ul>
            <li><strong>Clarity & Empowerment</strong> - Every step should feel intuitive and confidence-building.</li>
            <li><strong>Sustainability</strong> - We honor the seasons, reduce waste, and build resilient local food systems.</li>
            <li><strong>Community</strong> - Food is meant to be shared. We connect gardeners, households, nurseries, and farmstands.</li>
            <li><strong>Innovation with Heart</strong> - Technology should guide, mentor, and inspire - not overwhelm.</li>
          </ul>

          <h2>Our Story</h2>
          <p>
            GrowYourFoodApp was born from a simple observation: gardening guidance often stops at the soil,
            leaving households without support for the bigger picture of eating, preserving, and sharing.
          </p>
          <p>
            That insight sparked a vision: build an app that doesn't just track crops, but transforms how people
            live with local food. From the first seed to the last preserved jar, GrowYourFoodApp is designed to
            guide, mentor, and connect.
          </p>

          <h2>The GrowYourFoodApp Roadmap</h2>
          <p>
            GrowYourFoodApp isn't just another gardening app. We're not here to give you a plot map and call it done.
            We're building something much bigger - a journey that transforms how households grow, eat, and live with local food.
          </p>
          <ul>
            <li>
              <strong>January 2026 - The Garden Companion</strong><br />
              Launching on Vancouver Island with hyperlocal weather insights, crop tracking, and seasonal nudges.
            </li>
            <li>
              <strong>June 2026 - The Garden Concierge</strong><br />
              AI mentorship and nursery partnerships bring seeds and starters directly into your journey.
            </li>
            <li>
              <strong>January 2027 - The Garden Lifestyle</strong><br />
              Gardening becomes a lifestyle: plan meals around what's fresh, preserve surplus, and transform your pantry.
            </li>
            <li>
              <strong>June 2027 - The Farmstand Integration</strong><br />
              Non-gardeners join in. Local farmstands integrate into the app, gardeners can sell excess harvests,
              and the community becomes a connected local food ecosystem.
             </li>
             </ul>
             <p>
                <strong>Our Approach to Growth</strong><br />
                We are beginning in one region and staying there through every milestone. By focusing locally first, we can listen, refine, and build a system that truly works in daily life. Expansion to new regions is planned after January 2028, once the full Grow-Eat-Preserve-Share ecosystem is complete and proven.
            </p>
          <h2>Why Join Now</h2>
          <p>
            By getting in early, you're not just downloading an app - you're stepping into a movement.
            You'll experience each milestone as it unfolds, shaping the future of local food alongside us.
          </p>
          <p>
            GrowYourFoodApp is about more than gardening. It's about growing, eating, preserving,
            and sharing food in harmony with the seasons.
          </p>
          <p><strong>This is our plan. This is our roadmap. And it's only the beginning.</strong></p>

        </div>
      </div>
    </div>
);

export default AboutContent;
